export default {
  resolve (instance) {
    return [
      {
        icon: 'fa-pencil',
        title: instance.$t('order.title'),
        children: [
          {
            title: instance.$t('order.estimate'),
            to: 'order_estimate'
          },
          {
            title: '簡易計算',
            to: 'calc'
          }
        ],
        role: 'user',
        displayOrder: 1001
      },
      {
        icon: 'fa-pencil',
        title: instance.$t('request.title'),
        children: [
          {
            title: instance.$t('request.estimate'),
            to: 'request'
          }
        ],
        displayOrder: 1002
      },
      {
        icon: 'fa-file',
        title: instance.$t('list.title'),
        children: [
          {
            title: instance.$t('order.estimated'),
            to: 'order_estimated'
          },
          {
            title: instance.$t('order.settled'),
            to: 'order_settled'
          },
          {
            title: instance.$t('order.arranged'),
            to: 'order_arranged'
          },
          {
            title: instance.$t('order.completed'),
            to: 'order_completed'
          },
          {
            title: instance.$t('order.search'),
            to: 'order_search'
          }
        ],
        role: 'user',
        displayOrder: 2001
      },
      {
        icon: 'fa-cog',
        title: instance.$t('management.title'),
        children: [
          {
            title: instance.$t('customer.title'),
            to: 'customer'
          }
        ],
        role: 'user',
        displayOrder: 3001
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/app/menus.js